<div class="modal-body">
    <div *ngIf="rating <= 3">

        <div class="d-flex justify-content-center">
            <img src="../../../../../../assets/rating-1.png" class="rounded-circle rating-img"/>
        </div>

        <div class="d-flex flex-column align-items-center mt-4">
            <div class="h4">
                We are so sorry to hear that!
            </div>
            <div clas="h5 mt-2">
                Can you please tell us what happened so that we can work on it?
            </div>
        </div>

    </div>

    <div *ngIf="rating > 3">

        <div class="d-flex justify-content-center">
            <img src="../../../../../../assets/rating-3.png" class="rounded-circle rating-img"/>
        </div>

        <div class="d-flex flex-column align-items-center mt-4">
            <div class="h4 text-center">
                Thank you for your business and support!
            </div>
            <div clas="h5 mt-2">
                Can you please take a moment and rate us on one of our review platforms, your
                time is greatly appreciated! Help us inform other customers and grow our business:
            </div>
        </div>

        <div *ngIf="review_TrustpilotUrl != null && review_TrustpilotUrl.length > 0 || review_GoogleReviewsUrl != null && review_GoogleReviewsUrl.length > 0"
             class="d-flex flex-column mt-4 justify-content-center align-items-center">
            <div class="d-flex mb-3" *ngIf="review_TrustpilotUrl != null && review_TrustpilotUrl.length > 0">
                <div (click)="openLink(review_TrustpilotUrl)" style="cursor: pointer; margin-bottom: 24px;">
                    <img src="../../../../../../assets/logo-trustpilot.png" class="externalrating-img"/>
                </div>
            </div>

            <div class="d-flex mb-3" *ngIf="review_GoogleReviewsUrl != null && review_GoogleReviewsUrl.length > 0">
                <div (click)="openLink(review_GoogleReviewsUrl)" style="cursor: pointer;">
                    <img src="../../../../../../assets/logo-googlereviews.png" class="externalrating-img"/>
                </div>
            </div>
        </div>

        <div *ngIf="review_TrustpilotUrl != null && review_TrustpilotUrl.length > 0 || review_GoogleReviewsUrl != null && review_GoogleReviewsUrl.length > 0"
             class="d-flex mt-5" style="justify-content: center;">
            <button aria-label="Close" (click)="modal.dismiss('Cross click')" pButton type="button"
                    label="Close"></button>
        </div>
    </div>

    <div *ngIf="rating <= 3 || ((review_TrustpilotUrl === null || review_TrustpilotUrl.length <= 0) && (review_GoogleReviewsUrl === null || review_GoogleReviewsUrl.length <= 0))">

        <div class="d-flex flex-column mt-4">
      <textarea
              [(ngModel)]="feedbackMessage"
              [rows]="5"
              pInputTextarea
              [autoResize]="true"
              class="p-fluid">
      </textarea>
        </div>

        <div class="d-flex flex-row mt-5" style="justify-content: space-between;">
            <div class="">
                <button aria-label="Close" (click)="closeModal()" pButton type="button" label="Back"></button>
            </div>

            <div class="">
                <button (click)="saveReview()" pButton type="button" label="Save"></button>
            </div>
        </div>

    </div>
</div>
